export const appearanceHeaderClassnames = {
  h2: 'text-xl font-semibold mb-20',
  h3: 'my-12 font-semibold',
};
